import moment from 'moment';

export const buildQueryParams = (query) => {
    const result = {};

    if (!query) {
        return result;
    }

    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('riskLevels')) {
        result.riskLevels = query.getAll('riskLevels');
    }
    if (query.has('weatherEvents')) {
        result.weatherEvents = query.getAll('weatherEvents');
    }
    if (query.has('severities')) {
        result.severities = query.getAll('severities');
    }
    if (query.has('page')) {
        result.page = query.get('page');
    }
    if (query.has('page_size')) {
        result.page_size = query.get('page_size');
    }

    return result;
};
